import React, { createContext, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import getTimeAsPercentageOfDay from '@utils/functions/scheduler.functions';
import { isVisit } from '@utils/typeGuards/scheduler-event-typeguard';
import useScheduleAndDispatchContext from '@features/MapScheduler/Hooks/useScheduleAndDispatchContext';
import useSchedulerContext from '@features/MapScheduler/Hooks/useSchedulerContext';
import useRearrangeContext from '@features/MapScheduler/Hooks/useRearrangeContext';
import { EventState } from '../../Enums/event-state-enum';
export const EventContext = createContext(undefined);
export function EventContextProvider(params) {
    const { activeEvent, activeEventOriginalState, activeDate, setActiveSchedulerEvent } = useSchedulerContext();
    const { startRearrangingVisit, startTimeAdjustment, stopRearranging } = useRearrangeContext();
    const { openVisitModal, saveVisit } = useScheduleAndDispatchContext();
    const [eventState, setEventState] = useState(EventState.IDLE);
    const handleEventMouseUp = useCallback(() => {
        if (isVisit(params.event)) {
            setEventState(EventState.IDLE);
            stopRearranging();
            void saveVisit(params.event, activeEventOriginalState.current);
            setActiveSchedulerEvent(undefined);
        }
    }, [params.event, saveVisit, activeEventOriginalState, setActiveSchedulerEvent, stopRearranging]);
    useEffect(() => {
        var _a;
        if (((_a = activeEvent.current) === null || _a === void 0 ? void 0 : _a.key) === params.event.key && eventState !== EventState.IDLE) {
            document.addEventListener('mouseup', handleEventMouseUp);
        }
        return () => {
            document.removeEventListener('mouseup', handleEventMouseUp);
        };
    }, [activeEvent.current, params.event, eventState]);
    useEffect(() => {
        var _a;
        // If newly mounted component for a event currently being rearranged, continue  rearranging
        if (((_a = activeEvent.current) === null || _a === void 0 ? void 0 : _a.key) === params.event.key && isVisit(params.event)) {
            setEventState(EventState.REPOSITIONING);
            startRearrangingVisit(params.event, true);
        }
    }, []);
    const metadata = useMemo(() => {
        const startTimeAsPercentage = getTimeAsPercentageOfDay(params.event.start, activeDate);
        const endTimeAsPercentage = getTimeAsPercentageOfDay(params.event.end, activeDate);
        const overflowPrevDay = params.event.start.isBefore(activeDate);
        const overflowNextDay = params.event.end.isAfter(activeDate.endOf('day'));
        return {
            startTimeAsPercentage,
            endTimeAsPercentage,
            overflowPrevDay,
            overflowNextDay
        };
    }, [params.event.start, params.event.end, activeDate]);
    // useEffect(() => {
    //   console.log(targetVisit);
    //   // if (targetVisit?.key === params.visit.key) setEventState(EventState.REPOSITIONING);
    // }, [targetVisit]);
    const mouseDownTimer = useRef(null);
    const handleMouseUp = useCallback(() => {
        setEventState(EventState.IDLE);
        document.removeEventListener('mouseup', handleMouseUp);
    }, []);
    const handleMouseDown = useCallback(() => {
        mouseDownTimer.current = setTimeout(() => {
            if (isVisit(params.event)) {
                setActiveSchedulerEvent(params.event);
                setEventState(EventState.REPOSITIONING);
                mouseDownTimer.current = null;
                startRearrangingVisit(params.event, true);
            }
        }, 200);
        document.addEventListener('mouseup', () => {
            if (mouseDownTimer.current) {
                clearTimeout(mouseDownTimer.current);
                mouseDownTimer.current = null;
                if (isVisit(params.event))
                    openVisitModal(params.event.id);
            }
        }, { once: true });
    }, [params.event, openVisitModal, setActiveSchedulerEvent, startRearrangingVisit]);
    const handleResizeMouseDown = useCallback((timeType, snap) => {
        if (isVisit(params.event)) {
            setEventState(EventState.RESIZING);
            startTimeAdjustment(params.event, timeType, snap);
            // document.addEventListener('mouseup', handleMouseUp, { once: true });
        }
    }, [params.event]);
    // useEffect(() => {
    //   // Event Listener Cleanup
    //   return () => {
    //     if (mouseUpListener.current){
    //       console.log('cleaning up events');
    //       document.removeEventListener('mouseup', mouseUpListener.current);
    //       mouseUpListener.current = null;
    //     }
    //   };
    // }, []);
    const contextData = useMemo(() => {
        const value = {
            event: params.event,
            clusterInfo: params.clusterInfo,
            state: eventState,
            metadata,
            handleMouseDown,
            handleResizeMouseDown
        };
        return value;
    }, [params.event, params.clusterInfo, eventState, metadata]);
    return React.createElement(EventContext.Provider, { value: contextData }, params.children);
}
